export enum EErrorsMessagesKeys {
  MAX_SIZE = "ERRORS.MAX_SIZE",
  VALID_URL = "ERRORS.VALID_URL",
  ACCEPT_TYPES = "ERRORS.ACCEPT_TYPES",
  PARSING_FILE = "ERRORS.PARSING_FILE",
  COMPANY_STEP = "ERRORS.COMPANY_STEP",
  TELEMATIC_STEP = "ERRORS.TELEMATIC_STEP",
  TRY_LATER = "ERRORS.TRY_LATER",
}
